<template>
  <div class="content_sidebar content_sidebar-right sidebar-showingDrawer" style="">
    <div class="sidebar_header l-flex-between">
      Pages
    </div>
    <div class="drawer-wrapper">
      <div class="accordion">
        <div v-tippy :content="documentFileName" class="docName">
          {{ documentFileName }}
        </div>
      </div>

      <div
        v-for="(page, index) in documentImages"
        :key="index"
        :class="{'documentPage--current': currentPage === index + 1}"
        class="documentPage"
        @click="$emit('scrollToPage', index)"
      >
        <v-img :src="documentThumb(page.path, 300)"/>
        <div class="bar-action">
          <span class="page-number">{{ index + 1 }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type {documentImagesInterface} from '@/views/documentsV2/NewDocumentFieldsV2.vue';
import {documentThumb} from '@/utils/twicpics';

defineEmits(['scrollToPage']);

withDefaults(defineProps<{
  documentImages: documentImagesInterface[];
  documentFileName: string;
  currentPage?: number;
}>(), {
  currentPage: 1,
});
</script>

<style scoped>
.drawer-wrapper .docName {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.documentPage {
  border: 2px solid transparent;
  border-radius: 4px;
  cursor: pointer;
  transition: border-color 160ms ease;
}

.documentPage:hover {
  border-color: rgba(var(--v-theme-primary), 0.4);
}

.documentPage--current {
  border-color: rgb(var(--v-theme-primary));
}

.documentPage .page-number {
  bottom: 0;
  color: #666;
  display: block;
  font-size: 12px;
  font-weight: 400;
  height: 28px;
  left: 0;
  letter-spacing: normal;
  line-height: 28px;
  padding: 0 9px;
  position: absolute;
  text-align: center;
  text-decoration: none;
  text-transform: none;
}
</style>
